import { ApiStatus } from '../../api/constants/ApiConstants'

const { initial } = ApiStatus

export default {
  article: {},
  articleLoadedStatus: initial
}
